import React, {PropTypes as T} from 'react';
import {ModalContent, ModalFooter} from '../../common/modal';
import ErrorHeader from '../../common/modal/closeable_icon_error_header';
import Button from '../../common/button';
import translate from '../../../utils/translate';
import OmnitureUtils from '../../../utils/omniture-helper/omniture_utils';
import OmnitureBuilder from '../../../utils/omniture-helper/omniture_builder';

export default class RecaptchaError extends React.Component {
  static propTypes = {
    onClose: T.func
  };

  componentDidMount () {
    OmnitureBuilder
      .errorMessage(OmnitureUtils.getOmnitureErrorMessage(OmnitureUtils.REACAPTCHA_LOAD_ERROR))
      .sendSingle();
  }

  reloadPage = () => {
    if (window && window.location) {
      window.location.reload();
    }
  };

  render () {
    return (
      <div>
        <ErrorHeader onClose={this.props.onClose} title={translate('reCaptchaModule', 'SECURITY_CHECK')} />
        <ModalContent className="recaptcha__modal__content">
          <h2 className="recaptcha__modal__content_header">
            {translate('reCaptchaModule', 'RECAPTCHA_ERROR_MESSAGE')}
          </h2>
          {translate('reCaptchaModule', 'RECAPTCHA_ERROR_DESCRIPTION')}
        </ModalContent>
        <ModalFooter>
          <Button
            primary
            onClick={this.reloadPage}>
            {translate('reCaptchaModule', 'RECAPTCHA_RELOAD_BUTTON')}
          </Button>
        </ModalFooter>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/recaptcha/error_message.js